import { createFileRoute } from "@tanstack/react-router";
import { CreateFournisseurPage } from "@/features/achats/components/fournisseurs/CreateFournisseurPage";

export const Route = createFileRoute("/_app/achats/fournisseurs/create")({
  staticData: {
    title: "Nouveau fournisseur",
    showInBreadcrumb: true,
  },
  component: CreateFournisseurPage,
});
